import { format } from "date-fns";

import {
  DashboardDateRangeList,
  getDateRangeStartDate,
  getDateRangeEndDate,
} from "@/consts/Dashboard";

import { DateRangePicker, DateRangeType } from "@/components/DateRangePicker";
import FilterItemLabel from "@/components/FilterItemLabel";
import FilterRadioItem from "@/components/FilterRadioItem";

export type UsageDateRange = {
  preset: string; // DashboardDateRangeList의 value ("0" = 자유 입력)
  start_date: string; // yyyy-MM-dd
  end_date: string; // yyyy-MM-dd
};

export const DefaultUsageDateRange: UsageDateRange = {
  preset: "YTD",
  start_date: format(getDateRangeStartDate("YTD"), "yyyy-MM-dd"),
  end_date: format(getDateRangeEndDate("YTD"), "yyyy-MM-dd"),
};

type Props = {
  value: UsageDateRange;
  onChange: (value: UsageDateRange) => void;
};

export default function UsageDateFilter({ value, onChange }: Props) {
  const handleChangePreset = (preset: string) => {
    if (preset === "0") {
      // 자유 입력: 기존 기간 유지하고 피커만 활성화
      onChange({ ...value, preset });
      return;
    }
    onChange({
      preset,
      start_date: format(getDateRangeStartDate(preset), "yyyy-MM-dd"),
      end_date: format(getDateRangeEndDate(preset), "yyyy-MM-dd"),
    });
  };

  // DateRangePicker의 onSelect 타입이 div 네이티브 핸들러와 교차되어 있어 기존 사용처(DashboardFilter)처럼 any로 받는다
  const handleSelectRange = (e: any) => {
    const { from, to }: DateRangeType = e;
    onChange({
      ...value,
      start_date: format(from, "yyyy-MM-dd"),
      end_date: format(to, "yyyy-MM-dd"),
    });
  };

  return (
    <div className="p-5 bg-white rounded-xl outline outline-1 outline-offset-[-1px] outline-gray-D flex items-center gap-6 flex-wrap">
      <FilterItemLabel label="기간" />
      <DateRangePicker
        defaultValue={{
          from: new Date(value.start_date),
          to: new Date(value.end_date),
        }}
        disabled={value.preset !== "0"}
        onSelect={handleSelectRange}
      />
      <FilterRadioItem
        wrapperClassName="flex gap-4"
        name="usage_date_range"
        defaultValue={value.preset}
        radioList={DashboardDateRangeList}
        onChange={handleChangePreset}
      />
    </div>
  );
}
